import { ReactElement, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGetDagDetailsQuery } from 'store/airflow/enhancedAirflowApi';
import { findWorkflowTagValue, WorkflowTagCategory, WorkflowType } from 'utils/workflow';
import { workflowListPath } from 'routes/paths';
import { throwInfoToast } from 'utils/toasts';
import { infoMessages } from 'constants/messages';
import Loader from 'components/common/Loader/Loader';

interface WorkflowGuardProps {
    children: ReactElement;
}

const WorkflowGuard = ({ children }: WorkflowGuardProps) => {
    const { workflowId } = useParams();
    const navigate = useNavigate();

    const { data: dagDetailsData, isLoading } = useGetDagDetailsQuery(
        { dagId: workflowId ?? '' },
        { skip: !workflowId }
    );

    useEffect(() => {
        if (dagDetailsData && workflowId) {
            const type = findWorkflowTagValue(dagDetailsData, WorkflowTagCategory.TYPE);
            if (type === WorkflowType.BULK_COPY) {
                throwInfoToast({
                    message: infoMessages.useBulkCopy,
                });
                navigate(workflowListPath(true), { replace: true });
            }
        }
    }, [dagDetailsData, workflowId, navigate]);

    if (isLoading) {
        return <Loader />;
    }

    if (dagDetailsData) {
        const type = findWorkflowTagValue(dagDetailsData, WorkflowTagCategory.TYPE);
        if (type === WorkflowType.BULK_COPY) {
            return null;
        }
    }

    return children;
};

export default WorkflowGuard;
